/**
 * Returns 'white' or a dark color for text based on the background color's luminance.
 * Uses the WCAG relative luminance formula.
 */
export function getContrastColor(hex: string | null | undefined, darkColor = '#1a1a1a'): string {
  if (!hex) return 'white';

  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);

  if (isNaN(r) || isNaN(g) || isNaN(b)) return 'white';

  // WCAG relative luminance
  const toLinear = (c: number) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };

  const L = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

  // L > 0.179 means the background is light enough to need dark text
  return L > 0.179 ? darkColor : 'white';
}
